import i18n from '@/i18n';

const APP_TITLE = document.title; // pick up the default title from index.html

export default class TabTitle {
  static tKey: string | undefined;
  static tFields: object = {};

  static get() {
    return document.title;
  }

  static set(tKey: string | undefined, tFields: object = {}) {
    this.tKey = tKey;
    this.tFields = tFields;
    this.refresh();
  }

  static setKey(tKey: string | undefined) {
    this.tKey = tKey;
    this.refresh();
  }

  static setFields(tFields: object) {
    this.tFields = tFields;
    this.refresh();
  }

  static appTitle() {
    this.setKey(undefined);
    this.refresh();
  }

  static refresh() {
    if (this.tKey === undefined) { // undefined will revert to the app title from index.html
      document.title = APP_TITLE;
      return;
    }
    document.title = i18n.t(this.tKey, this.tFields) as string;
  }
}
